import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import UserHelper from '../../common/utils/userHelper';
import { IMAGES_BASE_PATH, API_GATEWAY_URL } from '../../config/constants';
import { getImage, getVideo } from '../../utils/helper';
import Video from './videoComp';
import RotatingTextSlide from "./Components/RotatingTextSlider";
import axios from 'axios';

interface EventData {
  is_header_banner_video?: boolean;
  header_banner_image?: string;
  header_banner_video?: string;
  title?: string;
  description?: string;
}

const Default: React.FC = () => {
  const eventId = UserHelper.getEventId();
  const userId = UserHelper.getUserId();

  const [data, setData] = useState<EventData | null>(null);

  const eventData = useSelector((state: any) => state.eventData); // optionally type this better

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${API_GATEWAY_URL}frontend/api/landing-page/event-id/${eventId}`);
        console.log('Landing page data:', res.data.data);
        setData(res.data.data);
      } catch (error) {
        console.error('Error fetching landing page data:', error);
      }
    };

    fetchData();
  }, [eventId]);

  const isVideo = data?.is_header_banner_video;
  const image = data?.header_banner_image;
  const video = data?.header_banner_video;
  const videoUrl = getVideo(video);

  const staticCSs = !isVideo
    ? {
        backgroundImage: `url(${getImage(image)})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }
    : {};

  return (
    <>
      {/* Home section */}
      <div className="single-section home-area" id="home" style={staticCSs}>
        {isVideo && <Video videoUrl={videoUrl} />}

        <div className="bg"></div>
        <div className="bg bg2"></div>
        <div className="bg bg3"></div>

        <div className="container h-100">
          <div className="row h-100 align-items-center">
            <div className="col-12 col-md-12 col-lg-8 home-content">
              <h1 className="main-head cd-headline clip is-full-width">
                <span>{eventData?.title?.substring(0, 200)}</span>
                <RotatingTextSlide eventData={eventData} />
              </h1>

              <p
                className="description"
                dangerouslySetInnerHTML={{
                  __html: eventData?.description?.substring(0, 500) || '',
                }}
              />

              <div className="button-area">
                <a className="btn scroll" href="/#schedule">Event Schedule</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Registration Success Message */}
      <div className="single-section about-area silver-bg" id="after-registration">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-sm-12">
              {/* Optional image or icon can go here */}
            </div>
            <div className="col-lg-7 col-sm-12">
              <div className="section-heading">
                <h2 className="section-title">Registration Successful 🎉</h2>
                <p className="section-description">
                  Thank you for registering! We’ve sent a confirmation email to your inbox.<br />
                  Please check your email and click the activation link to verify your account.
                </p>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Default;
